// دعوة لاتخاذ إجراء

import { useState } from "react";

export default function ContactCTA() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Contact Form:", formData);

    alert("تم إرسال طلبك بنجاح");

    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    });
  };

  const phoneNumber = "966500000000";

  const whatsappMessage = encodeURIComponent(
    "السلام عليكم، أرغب في طلب خدمة إعادة التدوير.",
  );

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${whatsappMessage}`;
  return (
    <>
      <section className="bg-gray-50 py-20 md:py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="mx-auto mb-14 max-w-2xl text-center">
            <span className="mb-3 inline-block text-sm font-semibold text-green-600">
              تواصل معنا
            </span>

            <h2 className="text-3xl font-bold leading-tight text-gray-900 md:text-4xl">
              لنبدأ رحلة التدوير معًا
            </h2>

            <p className="mt-5 leading-8 text-gray-600">
              لديك مواد قابلة لإعادة التدوير أو ترغب في معرفة المزيد عن خدماتنا؟
              تواصل معنا وسيسعد فريقنا بخدمتك.
            </p>
          </div>

          <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
            {/* Contact Information */}
            <div className="flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-gray-900">
                نحن هنا لمساعدتك
              </h3>

              <p className="mt-4 max-w-lg leading-8 text-gray-600">
                سواء كنت فردًا أو شركة أو منشأة، يمكنك التواصل معنا للحصول على
                المعلومات المناسبة وطلب خدمات إعادة التدوير.
              </p>

              <div className="mt-8 space-y-5">
                {/* Phone */}
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-green-100 text-green-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-.987a1.125 1.125 0 0 0-1.173.417l-.97 1.182a1.125 1.125 0 0 1-1.21.343 12.035 12.035 0 0 1-7.19-7.19 1.125 1.125 0 0 1 .343-1.21l1.182-.97c.35-.287.51-.742.417-1.173L6.937 3.03A1.125 1.125 0 0 0 5.846 2.18H4.5A2.25 2.25 0 0 0 2.25 4.43v2.32Z"
                      />
                    </svg>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500">الهاتف</p>
                    <p className="mt-1 font-semibold text-gray-900">
                      سيتم إضافة الرقم
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-green-100 text-green-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25H4.5a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0-8.69 5.213a1.125 1.125 0 0 1-1.16 0L2.25 6.75"
                      />
                    </svg>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500">البريد الإلكتروني</p>
                    <p className="mt-1 font-semibold text-gray-900">
                      info@example.com
                    </p>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-green-100 text-green-600">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      className="h-5 w-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                      />
                    </svg>
                  </div>

                  <div>
                    <p className="text-sm text-gray-500">الموقع</p>
                    <p className="mt-1 font-semibold text-gray-900">
                      المملكة العربية السعودية
                    </p>
                  </div>
                </div>
              </div>

              {/* Google Maps */}
              <div className="mt-10 overflow-hidden rounded-2xl border border-gray-200 bg-white">
                <div className="relative h-64 w-full md:h-72">
                  <iframe
                    title="موقع شركة خبراء التدوير"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3626.1806780426004!2d46.840193!3d24.6519085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2fa99df015de53%3A0x616dd8b450d5a948!2z2LTYsdmD2Kkg2K7YqNix2KfYoSDYp9mE2KrYr9mI2YrYsSDZhNil2LnYp9iv2Kkg2KrYr9mI2YrYsSDYp9mE2YXYrtmE2YHYp9iq!5e0!3m2!1sar!2ssa!4v1789392675488!5m2!1sar!2ssa"
                    className="h-full w-full border-0"
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  />
                </div>

                <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-600">
                      {/* Location Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="h-5 w-5"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 21s7-4.35 7-10a7 7 0 1 0-14 0c0 5.65 7 10 7 10Z"
                        />
                        <circle cx="12" cy="11" r="2.5" />
                      </svg>
                    </div>

                    <div>
                      <p className="font-semibold text-gray-900">
                        شركة خبراء التدوير
                      </p>

                      <p className="mt-1 text-sm leading-6 text-gray-500">
                        الرياض، المملكة العربية السعودية
                      </p>
                    </div>
                  </div>

                  <a
                    href="https://maps.app.goo.gl/zcfSCtF9bQGX5hoE7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center rounded-xl bg-gray-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-gray-800"
                  >
                    الحصول على الاتجاهات
                  </a>
                </div>
              </div>

              {/* CTA */}
              <div className="mt-10 rounded-2xl bg-green-600 p-6 text-white">
                <h4 className="text-lg font-bold">
                  هل لديك كمية من المواد القابلة للتدوير؟
                </h4>

                <p className="mt-2 text-sm leading-7 text-green-50">
                  أرسل لنا تفاصيل طلبك وسيتواصل معك فريقنا في أقرب وقت.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm md:p-8">
              <h3 className="text-xl font-bold text-gray-900">أرسل طلبك</h3>

              <p className="mt-2 text-sm leading-7 text-gray-500">
                املأ البيانات التالية وسنتواصل معك.
              </p>

              <div className="mb-6">
                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex w-full items-center justify-center gap-3 rounded-xl border border-green-200 bg-green-50 px-6 py-3.5 font-semibold text-green-700 transition hover:bg-green-100"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="h-5 w-5"
                  >
                    <path d="M20.52 3.48A11.86 11.86 0 0 0 12.08 0C5.53 0 .2 5.33.2 11.88c0 2.09.55 4.13 1.6 5.94L.1 24l6.34-1.66a11.86 11.86 0 0 0 5.64 1.43h.01c6.55 0 11.88-5.33 11.88-11.88 0-3.17-1.24-6.15-3.45-8.41ZM12.09 21.8h-.01a9.9 9.9 0 0 1-5.05-1.38l-.36-.21-3.76.98 1-3.66-.23-.38a9.87 9.87 0 0 1-1.51-5.27c0-5.46 4.45-9.9 9.92-9.9a9.84 9.84 0 0 1 7 2.9 9.9 9.9 0 0 1 2.9 7.01c-.01 5.46-4.45 9.91-9.9 9.91Zm5.43-7.42c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.76-1.66-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.09 4.5.71.31 1.27.49 1.7.63.72.23 1.37.2 1.89.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
                  </svg>
                  اطلب الخدمة عبر واتساب
                </a>

                <div className="my-5 flex items-center gap-3">
                  <div className="h-px flex-1 bg-gray-200" />
                  <span className="text-xs text-gray-400">أو</span>
                  <div className="h-px flex-1 bg-gray-200" />
                </div>
              </div>

              <form onSubmit={handleSubmit} className="mt-7 space-y-5">
                {/* Name */}
                <div>
                  <label
                    htmlFor="name"
                    className="mb-2 block text-sm font-medium text-gray-700"
                  >
                    الاسم
                  </label>

                  <input
                    id="name"
                    name="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="اكتب اسمك"
                    required
                    className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none transition focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                {/* Phone */}
                <div>
                  <label
                    htmlFor="phone"
                    className="mb-2 block text-sm font-medium text-gray-700"
                  >
                    رقم الهاتف
                  </label>

                  <input
                    id="phone"
                    name="phone"
                    type="tel"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="05xxxxxxxx"
                    required
                    className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none transition focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                {/* Email */}
                <div>
                  <label
                    htmlFor="email"
                    className="mb-2 block text-sm font-medium text-gray-700"
                  >
                    البريد الإلكتروني
                  </label>

                  <input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="example@email.com"
                    className="w-full rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none transition focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                {/* Message */}
                <div>
                  <label
                    htmlFor="message"
                    className="mb-2 block text-sm font-medium text-gray-700"
                  >
                    تفاصيل الطلب
                  </label>

                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="اكتب تفاصيل المواد أو الخدمة المطلوبة..."
                    required
                    className="w-full resize-none rounded-xl border border-gray-200 px-4 py-3 text-sm outline-none transition focus:border-green-500 focus:ring-2 focus:ring-green-100"
                  />
                </div>

                {/* Submit */}
                <button
                  type="submit"
                  className="w-full rounded-xl bg-green-600 px-6 py-3.5 font-semibold text-white transition hover:bg-green-700 active:scale-[0.99]"
                >
                  إرسال الطلب
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
